<template>
    <div class="multi-pie-chart">
        <div id="pie-popup" style="display: none;" v-tippy-html>
            <div v-if="hoveredNode" class="popover-content">
                <h3>{{hoveredNode.data.label}}</h3>
                <div class="amount">{{moneyFormatter(hoveredNode.value)}}</div>
                <div class="percentage">{{numeral(hoveredNode.value/total).format('0.00%')}} del ppto total</div>
            </div>
        </div>
        <svg :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
            <g :transform="'translate('+margin.left+','+margin.top+')'">
                <g :transform="'translate('+(chartWidth/2)+','+(chartHeight/2)+')'">
                    <text text-anchor="middle" dy="-10">AÑO</text>
                    <text class="big" text-anchor="middle" dy="10">{{text}}</text>

                    <g v-if="showInnerPie" v-for="d in pie(innerPieData)" class="arc" @mouseenter="hoveredNode = d" v-tippy="{html: '#pie-popup', followCursor: true, arrow: true, animation: 'fade'}">
                        <title>{{d.data.label}}</title>
                        <path :d="path(d)" :fill="d.data.color"></path>
                    </g>

                    <g v-if="showOuterPie" v-for="d in pie(outerPieData)" class="arc" @mouseenter="hoveredNode = d" v-tippy="{html: '#pie-popup', followCursor: true, arrow: true, animation: 'fade'}">
                        <title>{{d.data.label}}</title>
                        <path :d="outerPath(d)" :fill="d.data.color"></path>
                    </g>
                </g>
            </g>
        </svg>
    </div>

</template>
<style lang="scss">
    .multi-pie-chart{
        text{
            font-family: Roboto;
            font-weight: 500;
            font-size: 14px;
            &.big{
                font-size: 18px;
            }
        }
    }
</style>
<script>
    import * as d3 from 'd3';
    import numeral from 'numeral';
    import _ from 'lodash';
    import moneyFormatter from '../../Methods/MoneyFormatter';


    export default{
        data: function(){
            return {
                margin:{
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                },
                hoveredNode: null
            }
        },
        props:['data', 'dimensions', 'labels', 'width', 'height', 'text'],
        props: {
            data: {},
            dimensions: {},
            labels: {},
            width: {},
            height: {},
            text: {},
            showInnerPie: {default: true},
            showOuterPie: {default: true}
        },
        methods:{
            moneyFormatter: moneyFormatter,
            numeral: numeral
        },
        computed:{
            chartWidth: function(){
                return this.width - this.margin.left - this.margin.right;
            },
            chartHeight: function(){
                return this.height - this.margin.top - this.margin.bottom;
            },
            radius: function(){
                return Math.min(this.chartWidth, this.chartHeight) / 2;
            },
            pie: function(){
                return d3.pie()
                    .sort(null)
                    .value(function(d) {return d.sum; });
            },
            path: function(){
                return d3.arc()
                    .outerRadius(this.radius - 10)
                    .innerRadius(this.radius - 25);
            },
            outerPath: function(){
                return d3.arc()
                    .outerRadius(this.radius)
                    .innerRadius(this.radius - 5);
            },
            color: function(){
                return d3.scaleOrdinal(d3.schemeCategory10);
            },
            outerPieData: function(){
                if(this.data.length === 0)
                    return [];

                return [
                    {
                        label: this.labels[0],
                        color: '#da000c',
                        sum: this.data[0][0].sum
                    },
                    {
                        label: 'Restante',
                        color: '#ececec',
                        sum: this.data[2][0].sum - this.data[0][0].sum
                    },
                ]
            },
            innerPieData: function(){
                if(this.data.length === 0)
                    return [];

                return [
                    {
                        label: this.labels[1],
                        color: '#ff959a',
                        sum: this.data[1][0].sum
                    },
                    {
                        label: 'Restante',
                        color: '#dedede',
                        sum: this.data[2][0].sum - this.data[1][0].sum
                    },
                ]
            },
            total: function(){
                return _.sumBy(this.data[2], 'sum');
            }

        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/MultiPie.vue